module.exports = __webpack_public_path__ + "static/img/fish21.92db804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish21.png
// module id = btZw
// module chunks = 0